import { useCallback, useState } from "react";

export interface IReceiveDrawer {
  isOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  toggleMenu: () => void;
}

export function useReceiveDrawerState(): IReceiveDrawer {
  const [isOpen, setOpen] = useState(false);
  const openMenu = useCallback(() => setOpen(true), []);
  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((val) => !val), []);

  return { isOpen, openMenu, closeMenu, toggleMenu };
}
